/**
 * События чата для внешних слушателей контроллера (`ChatEventListener`).
 * Перечисление без полей — порт Dart-енума `ChatEvent`.
 */
export const ChatEvent = {
  complete: 'complete',
} as const;

export type ChatEvent = (typeof ChatEvent)[keyof typeof ChatEvent];
